// extracted by mini-css-extract-plugin
export default {"l":"_4358dd0feb"};